import _ from "lodash";
import api from "../services/api";
import odataMixin from "@/core/store/mixin/odata";
import crudMixin from "@/core/store/mixin/crud";
import module from "./module";

export default _.merge({}, odataMixin(api), crudMixin(api), module);
